import { FC } from 'react';
import { State } from 'redux/initialState';
import { useSelector } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';

import { Transaction } from 'types';

import { formatCurrencyDecimals, formatNumber } from 'utils/formats';

import IconTooltip from 'modules/_shared/components/Icon/IconTooltip';

import { useGetTransactionData } from '../hooks/useGetTransactionData';

type PartnerTransactionRowProps = {
  index: number;
  transaction: Transaction;
  operationType: string;
};

const PartnerTransactionRow: FC<PartnerTransactionRowProps> = ({
  index,
  transaction,
  operationType,
}) => {
  const { t } = useTranslate();

  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );

  const { data } = useGetTransactionData({
    transaction,
    operationType,
    nominalValue: actualSociety?.nominalValue || 0,
  });

  return (
    <tr className="bg-light inner-shadow">
      <td
        key={`transaction-number-${index}`}
        className="nk-tb-col text-center vertical-align-middle"
        colSpan={2}
      />

      <td
        key={`transaction-type-${index}`}
        className="nk-tb-col text-center vertical-align-middle"
      >
        <div className="d-inline-flex align-items-center">
          {t(data.type)}

          {transaction.comments && (
            <IconTooltip
              id={`transaction-comments-${index}`}
              tooltip={data.comments}
            />
          )}
        </div>
      </td>

      <td
        key={`transaction-date-${index}`}
        className="nk-tb-col text-center vertical-align-middle"
      />

      <td
        key={`transaction-amount-${index}`}
        className="nk-tb-col tb-col-xl text-right vertical-align-middle"
      >
        {formatCurrencyDecimals(data.amount)}
      </td>

      <td
        key={`transaction-premium-${index}`}
        className="nk-tb-col tb-col-xl text-right vertical-align-middle"
      >
        {formatCurrencyDecimals(data.premium)}
      </td>

      <td
        key={`transaction-shares-${index}`}
        className="nk-tb-col text-right vertical-align-middle"
      >
        {formatNumber(data.sharesCount)}
      </td>

      <td
        key={`transaction-class-${index}`}
        className="nk-tb-col tb-col-xl text-center vertical-align-middle flex-grow-1"
      >
        {data.className || '-'}
      </td>

      <td
        key={`transaction-from-${index}`}
        className="nk-tb-col tb-col-xl text-right vertical-align-middle"
      >
        {data.from ? formatNumber(data.from) : '-'}
      </td>

      <td
        key={`transaction-to-${index}`}
        className="nk-tb-col tb-col-xl text-right vertical-align-middle"
      >
        {data.to ? formatNumber(data.to) : '-'}
      </td>
      <td
        key={`transaction-${index}`}
        className="nk-tb-col tb-col-xl"
        colSpan={5}
      />
    </tr>
  );
};

export default PartnerTransactionRow;
